import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import ButtonWithConfirm from "components/button/buttonwithconfirm";
import {
  doClassParticipantEnrollNow
} from '../../redux/trainingclass/trainingClassState';

const CourseCard = ({ 
  recordData,
  enrollParticipant,
}) => {


  const onClickEnrollParticipantNow = () => {
    if (!recordData?.tcl_id) return;

    enrollParticipant({
      classeId: recordData.tcl_id,
    });
  };

  return (
    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200 dark:border-zinc-700 hover:shadow-lg transition-all dark:bg-white/10">
      <div className="pb-6 p-4">
        <div className="flex items-start justify-between mb-2">
          <h4 className="font-semibold text-sm dark:text-white">{recordData?.tcl_title}</h4>
          <span
            className={`inline-flex status-indicator ${recordData?.tcl_difficulty_name
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            >
              {recordData?.tcl_difficulty_name}
          </span>
        </div>
        <div className="text-xs text-slate-700 mb-3 dark:text-slate-100">
            <span>{recordData?.course_cat_name}</span>
            <span className="mx-1">•</span>
            <span>{recordData?.tcl_duration}</span>
        </div>
        <ButtonWithConfirm
          className="access-button btn-enroll-now w-full !h-8 "
          confirmationTitle="Enroll Now"
          confirmHandler={onClickEnrollParticipantNow}
        >
          Enroll Now
        </ButtonWithConfirm>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  enrollParticipant: (data) => dispatch(doClassParticipantEnrollNow(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseCard);

